import LoadingSlider from "../../../common/Loading/LoadingSlider";
import { cn } from "../../../../Utils/helper";
import Lottie from "lottie-react";
import Button from "../../Button/Button";

const BodyModalLoading = ({
  duration = "",
  showLoading = true,
  progress = 0,
  classNameLoadingContainer = "bg-transparent",
  text = "",
  loadingText = "",
  imageSrc = "",
  tipsText1 = "",
  iconText1 = "",
  iconText2 = "",
  tipsText2 = "",
  conclusionText = "",
  classNameImage = "",
  classNameImageContainer = "",
  animationSrc = "",
  buttonText = "",
  onButtonClick,
  classNameTipsText,
  loop = false,
}) => {
  return (
    <div
      className={cn(
        "w-full flex flex-col items-center justify-center gap-9 p-0",
        classNameLoadingContainer
      )}
      // style={{
      //   backgroundColor: "rgba(225, 227, 246, 0.85)",
      //   backdropFilter: "blur(4px)",
      //   WebkitBackdropFilter: "blur(4px)",
      // }}
    >
      <div className=" w-full flex flex-col items-center justify-center gap-[18px]">
        {showLoading && (
          <>
            <div>
              <p className="text-[#253FF6] font-bold text-sm">{loadingText}</p>
            </div>
            <div className="w-[120px]">
              {/* <LoadingSlider duration={duration} /> */}
              <LoadingSlider progress={progress} duration={duration} />
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col justify-center gap-6 w-full py-[42px] px-[30px]  rounded-xl bg-[#FFF]">
        <div className="text-center font-bold text-base text-[#253FF6]">
          <span>{text}</span>
        </div>
        <div className="flex flex-col h-[240px] p-6 justify-center items-center self-stretch ">
          <div
            className={cn(
              "flex justify-start items-start flex-1 w-full h-full",
              classNameImageContainer
            )}
          >
            <Lottie
              loop={loop}
              className="w-full h-full p-0"
              animationData={require(`../../../../images/animation/` +
                animationSrc)}
              // className={cn("w-[283.826px] h-[224.588px]", classNameImage)}
            />
          </div>
        </div>

        {/* <div className="flex flex-col justify-center font-medium text-[20px] w-full text-center text-[#253FF6]"></div> */}
        <div className="flex flex-col justify-center text-center text-[#253FF6] font-bold gap-4">
          <div>
            <p className={cn("text-xl whitespace-pre-line", classNameTipsText)}>
              {tipsText1} {iconText1}
              {tipsText2 && iconText2 ? (
                <>
                  <br />
                  <span>{tipsText2}</span>
                </>
              ) : null}{" "}
              {iconText2}
            </p>
          </div>
          {conclusionText && (
            <span className="text-base">{conclusionText}</span>
          )}
        </div>
        {buttonText && (
          <Button
            onClick={onButtonClick}
            className=" bg-[#253FF6] text-white font-medium  rounded-md text-xl mt-0 py-3 px-[18px]"
            text={buttonText}
          />
        )}
        {/* <div className="text-center text-sm text-[#A0A0A0] font-medium">
          <p>{t("quest.questDetails.yourSubmissionWillReviewed")}</p>
        </div> */}
      </div>
    </div>
  );
};

export default BodyModalLoading;
